export const MyStorage = {
  getItem:(key)=>{
    if (localStorage.getItem(key) && localStorage.getItem(key) !== "") {
      return localStorage.getItem(key);
    } else {
      return "";
    }
  },
  setItem:(key, value)=>{
    localStorage.setItem(key, value);
  }
}